import { Actions, TimeBar, WeekDayBar } from './atoms';
import { WeekViewDatePickerProps } from './types';
import { WeekViewDatePickerProvider } from './week-view-date-picker.provider';
import { WeekViewDatePickerStyles } from './week-view-date-picker.styles';

export const WeekViewDatePicker = ({ children, theme = 'light', ...rest }: WeekViewDatePickerProps) => {
  const styles = WeekViewDatePickerStyles.weekViewDatePicker({ theme });

  return (
    <WeekViewDatePickerProvider {...rest}>
      <section css={styles}>
        <WeekDayBar {...rest} />
        {children}
      </section>
    </WeekViewDatePickerProvider>
  );
};

WeekViewDatePicker.Actions = Actions;
WeekViewDatePicker.TimeBar = TimeBar;
